import React, { useState, useEffect } from "react";
import { db } from "../firebase/firebase-config";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const EditDogForm = () => {
    const [name, setName] = useState("");
    const [age, setAge] = useState("");
    const [breed, setBreed] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [phoneNumber2, setPhoneNumber2] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [description, setDescription] = useState("");
    const [gender, setGender] = useState("Male");
    const [isFriendlyWithDogs, setIsFriendlyWithDogs] = useState("Yes");
    const [isFriendlyWithKids, setIsFriendlyWithKids] = useState("Yes");
    const [spayedNeutered, setSpayedNeutered] = useState(false);
    const [rabiesShot, setRabiesShot] = useState(false);
    const [microchipped, setMicrochipped] = useState(false);
    const { dogId } = useParams();

    useEffect(() => {
        const fetchDogData = async () => {
            const docRef = doc(db, "dogs", dogId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const data = docSnap.data();
                setName(data.name);
                setAge(data.age);
                setBreed(data.breed);
                setPhoneNumber(data.phoneNumber);
                setPhoneNumber2(data.phoneNumber2);
                setEmail(data.email);
                setAddress(data.address);
                setDescription(data.description);
                setGender(data.gender);
                setIsFriendlyWithDogs(data.isFriendlyWithDogs);
                setIsFriendlyWithKids(data.isFriendlyWithKids);
                setSpayedNeutered(data.spayedNeutered);
                setRabiesShot(data.rabiesShot);
                setMicrochipped(data.microchipped);
            } else {
                alert("No such dog found!");
            }
        };

        fetchDogData();
    }, [dogId]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const docRef = doc(db, "dogs", dogId);
        try {
            await updateDoc(docRef, {
                name,
                age,
                breed,
                description,
                phoneNumber,
                phoneNumber2,
                email,
                address,
                gender,
                isFriendlyWithDogs:
                    isFriendlyWithDogs !== undefined
                        ? isFriendlyWithDogs
                        : false,
                isFriendlyWithKids:
                    isFriendlyWithKids !== undefined
                        ? isFriendlyWithKids
                        : false,
                spayedNeutered:
                    spayedNeutered !== undefined ? spayedNeutered : false,
                rabiesShot: rabiesShot !== undefined ? rabiesShot : false,
                microchipped: microchipped !== undefined ? microchipped : false,
            });
            alert("Dog information updated successfully!");
        } catch (error) {
            console.error("Error updating document: ", error);
        }
    };

    const formatPhoneNumber = (value) => {
        if (!value) return value;
        const phoneNumber = value.replace(/[^\d]/g, "");
        const phoneNumberLength = phoneNumber.length;
        if (phoneNumberLength < 4) return phoneNumber;
        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
            3,
            6
        )} - ${phoneNumber.slice(6, 10)}`;
    };

    const handleNumberChange = (event, setPhoneNumber) => {
        const formattedPhoneNumber = formatPhoneNumber(event.target.value);
        setPhoneNumber(formattedPhoneNumber);
    };

    return (
        <div className="mainContainer">
            <div className="cancel">
                <Link to="/home">Cancel</Link>
            </div>
            <form onSubmit={handleSubmit} className="addDogForm">
                <label>Editing {name}</label>
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Dog's Name"
                    required
                />
                <input
                    type="number"
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                    placeholder="Dog's Age"
                    required
                />
                <input
                    type="text"
                    value={breed}
                    onChange={(e) => setBreed(e.target.value)}
                    placeholder="Dog's Breed"
                    required
                />
                <select
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                    required
                    className="genders"
                >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                </select>
                <input
                    type="text"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Medical issues? No pet zones? Allergies? Put N/A if none"
                    required
                />
                <input
                    type="tel"
                    value={phoneNumber}
                    onChange={(e) => handleNumberChange(e, setPhoneNumber)}
                    placeholder="Primary Phone Number"
                    pattern="\(\d{3}\) \d{3} - \d{4}"
                    title="Enter a phone number in the format: (123) 456 - 7890"
                    required
                />
                <input
                    type="tel"
                    value={phoneNumber2}
                    onChange={(e) => handleNumberChange(e, setPhoneNumber2)}
                    placeholder="Secondary Phone Number"
                    pattern="\(\d{3}\) \d{3} - \d{4}"
                    title="Enter a phone number in the format: (123) 456 - 7890"
                    required
                />
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email Address"
                />
                <input
                    type="address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="(Optional) Home Adress"
                />
                <div className="optionalDescriptionContainer">
                    <p>Optional</p>
                    <select
                        value={isFriendlyWithDogs}
                        onChange={(e) => setIsFriendlyWithDogs(e.target.value)}
                        className="genders"
                    >
                        <option value="Yes">Friendly with other dogs</option>
                        <option value="No">Not friendly with other dogs</option>
                    </select>
                    <select
                        value={isFriendlyWithKids}
                        onChange={(e) => setIsFriendlyWithKids(e.target.value)}
                        className="genders"
                    >
                        <option value="Yes">Friendly with kids</option>
                        <option value="No">Not friendly with kids</option>
                    </select>
                    <div className="optionalDescriptions">
                        <label>
                            <input
                                type="checkbox"
                                name="spayedNeutered"
                                checked={spayedNeutered}
                                onChange={() =>
                                    setSpayedNeutered(!spayedNeutered)
                                }
                            />
                            Spayed / neutered
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                name="rabiesShot"
                                checked={rabiesShot}
                                onChange={() => setRabiesShot(!rabiesShot)}
                            />
                            Rabies shot
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                name="microchipped"
                                checked={microchipped}
                                onChange={() => setMicrochipped(!microchipped)}
                            />
                            Microchipped
                        </label>
                    </div>
                </div>
                <button type="submit">Update Dog</button>
            </form>
        </div>
    );
};

export default EditDogForm;
